import React, { ChangeEventHandler, FocusEventHandler } from 'react';
import InputWrapper from './input-wrapper';

export interface TextboxProps {
  onChange?: ChangeEventHandler<HTMLTextAreaElement>;
  onBlur?: FocusEventHandler<HTMLTextAreaElement>;
  name: string;
  label: string;
  helpNote?: string;
  defaultValue?: string | number | readonly string[];
  disabled?: boolean;
  className?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextboxProps>(
  ({ onChange, onBlur, name, label, helpNote, defaultValue, disabled, className }, ref) => {
    return (
      <InputWrapper label={label} helpNote={helpNote}>
        <textarea
          defaultValue={defaultValue}
          className={`form-control col-sm-8 col-md-6 ${className || ''}`}
          onChange={onChange}
          onBlur={onBlur}
          name={name}
          ref={ref}
          disabled={disabled}
        />
      </InputWrapper>
    );
  },
);

export default Textarea;
